import script from "./InlineEditableText.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineEditableText.vue?vue&type=script&setup=true&lang=ts"

import "./InlineEditableText.vue?vue&type=style&index=0&id=4f22426e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f22426e"]])

export default __exports__